export const userState = {
    access_token: '',
    expires: '',
    refresh_token: '',
    refresh_expires: ''
};
